// extracted by mini-css-extract-plugin
module.exports = {"modal__title":"modal__title-303IP","modal__infoIcon":"modal__infoIcon-3hkkV","modal__conditions":"modal__conditions-1foCo"};